import styled, { css, keyframes } from 'styled-components';
import { NavLink } from 'react-router-dom';

type BlockProps = {
  $isDisabled: boolean;
  $isSelected?: boolean;
  $disableReason: 'none' | 'blocked' | 'subscriptionSlotInactive';
};

const selectedBorderPulse = (ringColor: string) => keyframes`
  0%,
  100% {
    border-color: ${ringColor};
    box-shadow: inset 0 0 0 0 ${ringColor}00;
  }
  50% {
    border-color: ${ringColor};
    box-shadow: inset 0 0 0 3px ${ringColor}55;
  }
`;

export const StyledBlock = styled(NavLink)<BlockProps>`
  text-decoration: none;
  width: 54px;
  height: 54px;
  border: 3px solid transparent;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  margin: 2px 0;
  box-sizing: border-box;
  pointer-events: ${({ $isDisabled }) => ($isDisabled ? 'none' : 'all')};
  transition: border-color 0.22s ease;

  ${({ $isDisabled }) =>
    $isDisabled &&
    css`
      background: transparent;
    `}

  ${({ $isDisabled, theme }) =>
    !$isDisabled &&
    css`
      &:hover {
        border-color: ${theme.color.brightTurquoise};
      }
    `}

  ${({ $isDisabled, $isSelected, theme }) =>
    !$isDisabled &&
    $isSelected &&
    css`
      border-color: ${theme.color.brightTurquoise};
      animation: ${selectedBorderPulse(theme.color.brightTurquoise)} 2.4s
        ease-in-out infinite;
    `}

  &.active {
    ${({ $isDisabled, $isSelected, theme }) =>
      !$isDisabled &&
      !$isSelected &&
      css`
        border-color: ${theme.color.brightTurquoise};
      `}
  }

  @media (prefers-reduced-motion: reduce) {
    ${({ $isSelected }) =>
      $isSelected &&
      css`
        animation: none;
      `}
  }
`;
